// Heads-up display: score, wave, and multiplier along the top of the field.

import type { GameState } from '../core';
import { FIELD_W } from '../core';
import { PALETTE } from './palette';

type Ctx = CanvasRenderingContext2D;

export function drawHud(ctx: Ctx, state: GameState): void {
  ctx.textBaseline = 'top';
  ctx.fillStyle = PALETTE.hud;
  ctx.font = '600 28px ui-monospace, monospace';
  ctx.textAlign = 'center';
  ctx.fillText(String(state.score).padStart(6, '0'), FIELD_W / 2, 12);

  ctx.font = '500 16px ui-monospace, monospace';
  ctx.fillStyle = PALETTE.hudDim;
  ctx.textAlign = 'left';
  ctx.fillText(`WAVE ${state.wave}`, 16, 16);

  ctx.textAlign = 'right';
  ctx.fillText(`x${state.scoreMultiplier}`, FIELD_W - 16, 16);

  if (state.reserveCities > 0) {
    ctx.textAlign = 'right';
    ctx.fillText(`+${state.reserveCities}`, FIELD_W - 16, 38);
  }
}
